import { CheckCircle, ErrorCircle } from '@ori-ui/icons';

export const EMAIL_INPUT = 'email-input';

export const adornmentIcons = {
  error: <ErrorCircle color="error" />,
  success: <CheckCircle color="inherit" />,
};
